enum LogTypes {
  EVERGREEN_TASK_FILE = "EVERGREEN_TASK_FILE",
  EVERGREEN_TASK_LOGS = "EVERGREEN_TASK_LOGS",
  EVERGREEN_TEST_LOGS = "EVERGREEN_TEST_LOGS",
  EVERGREEN_COMPLETE_LOGS = "EVERGREEN_COMPLETE_LOGS",
  LOCAL_UPLOAD = "LOCAL_UPLOAD",
}

enum LogRenderingTypes {
  Default = "default",
  Resmoke = "resmoke",
}

enum CaseSensitivity {
  Sensitive = "sensitive",
  Insensitive = "insensitive",
}

enum MatchType {
  Exact = "exact",
  Inverse = "inverse",
}

enum SearchBarActions {
  Filter = "filter",
  Highlight = "highlight",
  Bookmark = "bookmark",
}

enum FilterLogic {
  And = "and",
  Or = "or",
}

enum WordWrapFormat {
  Aggressive = "aggressive",
  Standard = "standard",
}

enum CopyFormat {
  Jira = "jira",
  Raw = "raw",
}

export {
  CaseSensitivity,
  CopyFormat,
  FilterLogic,
  LogRenderingTypes,
  LogTypes,
  MatchType,
  SearchBarActions,
  WordWrapFormat,
};
